import React, { useState } from 'react'
import { Link, NavLink } from 'react-router-dom';
import UserListGroup from './UserListGroup';

export default function ListGroup() {
   
      
     
  return (
    <>
    <div className="col-md-4 col-12 col-sm-4 mb-5">
               {
                  localStorage.getItem("role")==="@A*_s&_k!=!@h!-%"?
                  <div className="list-group">
        <NavLink
          to="/my-account"
          className="list-group-item list-group-item-action  mb-1"
          aria-current="true"
        >
            <i className="fa fa-home fs-4"></i>
          <span className="float-end">HOME</span>
        </NavLink>
       
        
          <NavLink
          to="/admin/testimonial"
          className="list-group-item list-group-item-action "
          aria-current="true"
        >
            <i className="fa fa-star fs-4"></i>
          <span className="float-end">TESTIMONIALS</span>
        </NavLink>
        <NavLink
          to="/admin/user"
          className="list-group-item list-group-item-action "
          aria-current="true"
        >
            <i className="fa fa-users fs-4"></i>
          <span className="float-end">USER</span>
        </NavLink>
        <NavLink
          to="/admin/newsletter"
          className="list-group-item list-group-item-action "
          aria-current="true"
        >
            <i className="fa fa-envelope fs-4"></i>
          <span className="float-end">NEWSLETTER</span>
        </NavLink>
        <NavLink
          to="/admin/booking"
          className="list-group-item list-group-item-action "
          aria-current="true"
        >
            <i className="fa fa-shopping-bag fs-4"></i>
          <span className="float-end">BOOKING</span>
        </NavLink>
        
        <NavLink
          to="/admin/offers"
          className="list-group-item list-group-item-action "
          aria-current="true"
        >
            <i className="fa fa-shopping-bag fs-4"></i>
          <span className="float-end">USER OFFERS</span>
        </NavLink>
        <NavLink
          to="/admin/roomcart"
          className="list-group-item list-group-item-action "
          aria-current="true"
        >
            <i className="fa fa-shopping-bag fs-4"></i>
          <span className="float-end">ROOM CART</span>
        </NavLink>
       
        <NavLink
          to="/admin/contact"
          className="list-group-item list-group-item-action "
          aria-current="true"
        >
            <i className="fa fa-phone fs-4"></i>
          <span className="float-end">CONTACT US</span>
        </NavLink>
        <NavLink
          to="/admin/gallery"
          className="list-group-item list-group-item-action "
          aria-current="true"
        >
            <i className="fa fa-phone fs-4"></i>
          <span className="float-end">GALLERY</span>
        </NavLink>
        <NavLink
          to="/admin/corporate-query"
          className="list-group-item list-group-item-action "
          aria-current="true"
        >
            <i className="fa fa-phone fs-4"></i>
          <span className="float-end">CORPORATE QUERY</span>
        </NavLink>
        <NavLink
          to="/admin/enquery"
          className="list-group-item list-group-item-action "
          aria-current="true"
        >
            <i className="fa fa-phone fs-4"></i>
          <span className="float-end">BANQUET QUERY</span>
        </NavLink>
      
                  </div>
                  :
                  <UserListGroup/>
                  



               } 
                </div>
    </>
  )
}
